import { z } from 'zod';

export const deleteAccountSchema = z.object({
  password: z.string().min(1, 'Password is required to delete account'),
});

export type DeleteAccountPayload = z.infer<typeof deleteAccountSchema>;
